export type DashboardFinancialIndicatorsData = {
	revenue: number[],
	expenses: number[]
}

export enum DashboardFinancialIndicatorsPeriods
{
	MESE = "Ultimo mese",
	TRE_MESI = "Ultimi 3 mesi",
	SEI_MESI = "Ultimi 6 mesi",
	ANNO = "Ultimo anno"
}
